import React from 'react';
import PieOrDonutChart from './pieChart';
import { getPieChartData } from 'src/blades/api';
import { numberFormat } from 'highcharts';
import numberFormatter from 'src/utils/numberFormatter';
const chartProps = {
    type: "line",
    backgroundColor: "Transparent",
    height: 400,
    marginBottom: 100,
    marginTop: 30,
    style: {
        fontFamily: "Segoe UI",
    }
};

const otherOptions = (module) => {
    module = module?.toLowerCase();
    const config = {
        cards:{
            prefix:': ',
            decimals:0
        },
        default:{
             prefix:'$',
            decimals:0
        }
    }
    const {prefix,decimals} = config[module] || config['default']
   return({
    title: { text: '' }, legend: {
        enabled: true, layout: 'vertical', align: 'right', itemHoverStyle: { "color": "#4096ff", }, itemMarginBottom: 20, itemDistance: 20, itemStyle: { "color": "rgba(255, 255, 255, 0.80)", "cursor": "pointer", "fontSize": "12px", "fontWeight": "400", "textOverflow": "ellipsis" }, labelFormatter: function () {
            const { number: value, suffix = '' } = numberFormatter(this.y)
            return `<div class="balance-graph-item">
    <span>${this.name}</span>
    <span>${prefix}${numberFormat(value,decimals, '.', ',')} ${suffix}</span>
    </div>`
        }, useHTML: true
    }, credits: { enabled: false },
    tooltip: {
        formatter: function () {
            const { number: value, suffix = '' } = numberFormatter(this.y)
            return `${this.point.name}: <b>${prefix}${numberFormat(value, decimals, '.', ',')}${suffix}</b>`;
        }
    },
    plotOptions: {
        series: {
            allowPointSelect: true,
            cursor: 'pointer',
            showInLegend: true,
            dataLabels: {
                enabled: false,
            },
        }
    },
    lang: {
        thousandsSep: ',' // Set comma as the thousands separator
    },
})
}
const CryptoBalancesChart = ({ module }) => {
    return (
        <PieOrDonutChart fetchMethod={getPieChartData} chartProperties={chartProps} shouldFetch={true} fetchOptions={null} isDonut={true} donutInnerSize={'75%'} hasFetchParams={true} fetchParams={[module]} seriesKey="currenciesModels" otherOptions={otherOptions(module)} shouldClear = {true}/>
    )
}

export default React.memo(CryptoBalancesChart)